const STATUSES = {
    Active: {
        label: "Active",
        actions: ['View', 'Create New version'],
        transitions: ['Unpublish']
    },
    Inactive: {
        label: "Inactive",
        actions: ['View'],
        transitions: ['Make as Draft', 'Archive']
    },
    Archived: {
        label: "Archived",
        actions: [],
        transitions: []
    },
    Draft: {
        label: "Draft",
        actions: ['View', 'Edit', 'Delete'],
        transitions: ['On Hold', 'Send for Approval']
    },
    "In Review": {
        label: "In Review",
        actions: ['View'],
        transitions: ['Approve', 'Reject']
    },
    Approved: {
        label: "Approved",
        actions: ['View'],
        transitions: ['Make as Draft', 'Publish']
    },
    Rejected: {
        label: "Rejected",
        actions: ['View'],
        transitions: ['Make as Draft', 'Make as Hold']
    },
    "On Hold": {
        label: "On Hold",
        actions: ['View', 'Delete'],
        transitions: ['Make As Draft']
    },
};

const APPLICATIONS = { Intelliread: "Intelliread", Legacy: "Legacy" };

const TYPES = { Standard: "Standard", "Fast Forward": "Fast Forward" };

// const CATEGORIES = {
//     "Training Program": "Training Program",
//     Event: "Event",
//     Webinar: "Webinar",
// };

const LOCATIONS = {
    Online: "Online",
    "In-Person": "In-Person",
    External: "External",
};

const MODES = {
    TIMED: "Timed",
    FLEXIBLE: "Flexible",
    FIXED: "Fixed",
};

const APPROVAL_STATUSES = {
    Pending: "Pending",
    Approved: "Approved",
};

const APPROVAL = {
    0: "Not approved",
    1: "Approved",
    null: "Not responded",
};

// export const course = {
//     STATUSES,
//     APPLICATIONS,
//     TYPES,
//     CATEGORIES,
//     LOCATIONS,
//     MODES,
//     APPROVAL_STATUSES,
//     APPROVAL,
// };

const QUESTION_TYPES = [
    "MCQ", "MSQ", "MTF", "FIB"
]


const TAXONAMY = [
    "LOW", "MEDIUM", "HIGH"
]

const CATEGORIES = [
    "DIRECT", "APPLICATION", "SYNTHESIS"
]
const GROUP = [
    "GROUP1", "GROUP2", "GROUP3"
]

const STYLES = {
    "text": "Text",
    "text-and-image": "Image",
    "text-and-audio": "Audio",
    "text-and-video": "Video",
};

const DISPLAY_TEMPLATE = [
    "Side-by-Side", "Top-and-Bottom"
]

const MATCHRELATIONS = ['One-to-One', 'One-to-Many', 'Many-to-One', 'Many-to-Many'];


export const question = {
    QUESTION_TYPES,
    TAXONAMY,
    CATEGORIES,
    GROUP,
    STYLES,
    DISPLAY_TEMPLATE,
    MATCHRELATIONS
}
